import { Spinner } from '@/components/shared';
import dynamic from 'next/dynamic';
import React, { Suspense, lazy, useEffect, useState, type ComponentType, type FC } from 'react';
import { IViewResolverComponentProps } from 'Components/view-resolver/view-resolver.interface';

const CheckoutPage: FC<IViewResolverComponentProps> = () => {
  const [Checkout, setCheckout] = useState<ComponentType<any> | null>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // @ts-ignore
      setCheckout(lazy(() => import('beautyFrontendPlp/Checkout')));
    }
  }, []);
  return (
    <>
      <Suspense fallback={<Spinner />}>{Checkout ? <Checkout /> : null}</Suspense>
    </>
  );
};

export default CheckoutPage;
